import React from "react";
import { ReactNode } from "react";
import { StaticContext } from "react-router";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Pager } from "../components/Pager";
import { Search } from "../components/Search";
import pic from "../../assets/images/talking.png";
import { ActivityInfo } from "../../models/system";
import { getEduAcvities } from "../../apis/api";
//@ts-ignore
@withRouter
export class Talking extends React.Component<Partial<RouteComponentProps<{ type: string, name: string }>>> {
    state = { page: 0, pageSize: 12, list: [] as ActivityInfo[], total: 0 as number }

    componentDidMount(): void {
        getEduAcvities(this.state.page, this.state.pageSize, parseInt(this.props.match?.params?.type ?? "2")).then((res) => {
            this.setState({ list: res.content, total: res.pageCount });
        })

    }
    private navigateToPage: (page: number) => void = (page: number) => {
        this.setState({ page: page });
        getEduAcvities(page, this.state.pageSize, parseInt(this.props.match?.params?.type ?? "2")).then((res) => {
            this.setState({ list: res.content });
        })
    }
    // componentWillReceiveProps(nextProps: Readonly<Partial<RouteComponentProps<{ type: string; name: string; }, StaticContext, unknown>>>, nextContext: any): void {
    //     getEduAcvities(this.state.page, this.state.pageSize, parseInt(nextProps.match?.params?.type ?? "2")).then((res) => {
    //         this.setState({ list: res.content });
    //     })
    // }

    render(): React.ReactNode {
        return (
            <>
                <div className="talking">
                    <Search className="talking_search" ></Search>


                    <div className="items">
                        {
                            this.state.list.map((item, index) => (
                                <div className="item">
                                    <div className="img">
                                        <img src={item.pic}></img>
                                        <div className="bottom_btn">
                                            <div className="btn">点击预约</div>
                                        </div>
                                    </div>
                                    <div className="about_talking">
                                        <p>主讲人:{item.assist}</p>
                                        <p className="subject">讲座主题：{item.title}</p>
                                        <p>地点/时间：{item.address}/{item.date}</p>
                                    </div>
                                </div>
                            ))
                        }



                    </div>
                    <Pager pageCount={Math.ceil(this.state.total / this.state.pageSize)} pageSize={this.state.pageSize} curpage={0} onNavigatePage={(e) => { this.navigateToPage(e) }}></Pager>
                </div>
            </>
        )
    }
}